/**
 * Các giá trị đang fix cứng trên chương trình
 * NVTUAN1 11.08.2022
 */
export default {
  AllText: '<<Tất cả>>', // Text "<<Tất cả>>",
  SelectAllText: '<<Chọn tất>>',
  AllStandardText: 'Tất cả', // Text "Tất cả",
  SummaryText: '<<Tổng hợp>>', // Text "<<Tổng hợp>>" trong combobox
  SummaryStandardText: 'Tổng hợp', // Text "Tổng hợp" trong combobox
  AllBudgetSourceId: 'a0624cfa-d105-422f-bf20-11f246704dc3', // Id nguồn tất cả
  SummaryStockId: 'DC36CE47-F62C-41DB-A3EE-184211CBC405', // Id kho tổng hợp
  AllInventoryCategoryId: 'c13a0f3e-1d45-11ed-a597-005056b30259', // Id loại vật tư hàng hóa
  AllFixedAssetCategoryId: '068643bc-85c6-11ed-be2c-005056b30259', // Id loại tài sản cố định
  AllDepartmentId: '1D496496-AEB2-4EA9-8F1A-5859227AC7E6', // ID tất cả phòng ban
  SummaryFixedAssetCategoryId: 'CCEE2898-3703-46AA-A6BC-1A27B65D0AC1', // ID tổng hợp Loại tài sản cố định
  GuidEmpty: '00000000-0000-0000-0000-000000000000', // Guid Empty
};
